export function hms(sec: number | undefined): string | undefined {
  if (!sec) return undefined;
  const h: string = Math.floor(sec / 3600)
    .toString()
    .padStart(2, '0');
  const m: string = Math.floor((sec % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const s: string = (sec % 60).toString().padStart(2, '0');

  return `${h}:${m}:${s}`;
}

export function hmsToSec(hms: string): number {
  const [h, m, s] = hms.split(':').map(Number);

  return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
}
